"use client";

import { useEffect, useState } from "react";

export type MeUser = { id: string; name: string; email: string } | null;

/** Lightweight "who am I" for chrome (header/footer). Pages that need more call /api/auth/me themselves. */
export function useMe(deps: unknown[] = []) {
  const [user, setUser] = useState<MeUser>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch("/api/auth/me")
      .then((r) => r.json())
      .then((d) => {
        if (alive) setUser(d.user ?? null);
      })
      .catch(() => {
        if (alive) setUser(null);
      })
      .finally(() => {
        if (alive) setReady(true);
      });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { user, ready, setUser };
}
